import React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import BlueImage from '../images/blue-bg.png'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import brandingConfig from '../../../../config/brandingConfig'

export default function CofounderOpeningWidthCard() {
    const { formatMessage } = useIntl()
    return (
        <div className='mb-4 rounded-2'>
            <div className='p-0'>
                <div className='d-flex flex-column justify-content-between flex-md-row align-items-center'>
                    <div className='documents-card-v2 flex-grow-1 bg-white w-100'>
                        <div className={`d-flex flex-column flex-md-row justify-self-start cardLayout`}>
                            <Link to={''} className='doc-image'>
                                <img src={BlueImage} alt='documents thumbnail' className={`d-flex `} />
                            </Link>
                            <div className='d-flex flex-column w-100 p-4 justify-content-between'>
                                <div className='d-flex flex-column'>
                                    <div className='d-flex justify-content-between align-items-center mb-4'>
                                        <div className=''>
                                            <div className='d-flex align-items-center gap-4'>
                                                <h5 className='font-size-16 gap-2  '>{brandingConfig.brandName}</h5>
                                                <span
                                                    className='px-4 py-1 font-size-14 mb-2'
                                                    style={{ borderRadius: '80px', border: '1px solid #CFE0FA' }}
                                                >
                                                    Technology
                                                </span>
                                            </div>
                                            <p className='font-size-13 text-muted'>Fundraising Process Made Easy</p>

                                            <h1 className='font-size-16'>We Are Looking For Dedicated Co-Founder</h1>
                                            <div className='d-flex gap-2'>
                                                <p className='m-0'><span><img className='me-1' src={toAbsoluteUrl('/media/icons/cofounder-connect/ic-location.svg')} alt="" /></span>Gurugram, India</p>
                                                <p className='m-0'><span><img className='me-1' src={toAbsoluteUrl('/media/icons/cofounder-connect/ic-idea.svg')} alt="" /></span>Technical, Sales</p>
                                                <p className='m-0'><span><img className='me-1' src={toAbsoluteUrl('/media/icons/cofounder-connect/ic-baggage-claim.svg')} alt="" /></span>Remote, Hybrid, Full-time Office</p>
                                            </div>
                                        </div>
                                    </div>
                                    <p className='font-size-13 text-muted'>Co-Founder Requirements will go here.Co-Founder Requirements will go here.Co-Founder Requirements will go here.Co-Founder Requirements will go here.Co-Founder Requirements will go here.</p>

                                    <h1 className='font-size-14'>Founders</h1>
                                    <div className='d-md-flex justify-content-between'>
                                        <div className='d-flex align-items-center gap-1 mb-4 mb-md-auto mt-2 mt-md-auto'>
                                            <DisplayImage className='rounded-circle' height={32} width={32} imgName='' alt='profile-pic' />
                                            <div className='me-4'>
                                                <p className='font-size-12 fw-semibold text-dark m-0'>Toshendra Sharma</p>
                                                <p className='font-size-12 text-muted m-0'>Founder & CEO</p>
                                            </div>
                                            <DisplayImage className='rounded-circle' height={32} width={32} imgName='' alt='profile-pic' />
                                            <div>
                                                <p className='font-size-12 fw-semibold text-dark m-0'>Rohendra Singh</p>
                                                <p className='font-size-12 text-muted m-0'>Founder & CEO</p>
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-end'>
                                            <Link
                                                to={'cofounder-details'}
                                                className='btn btn-primary cta-documents'
                                            >
                                                {formatMessage({ id: 'Know More' })}
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
